var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "welcome pb-2" }, [
    _c("h1", [_vm._v("Bienvenido,")]),
    _c("p", { staticClass: "welcome_company" }, [_vm._v(_vm._s(_vm.name))]),
    _vm.isMaster == 1
      ? _c(
          "div",
          [
            _c(
              "v-icon",
              {
                staticClass: "mb-1 mr-1",
                attrs: { small: "", color: "primary" },
              },
              [_vm._v("mdi-guy-fawkes-mask")]
            ),
            _c("span", [_vm._v("Master")]),
          ],
          1
        )
      : _vm._e(),
    _c("p", [_vm._v(_vm._s(_vm.company))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }